import { PerspectiveFrustum, Math as CesiumMath, Cartesian3, Matrix3, } from "cesium";
import React, { useState, useRef } from "react";
import { useCesiumViews } from "../../Contexts/ViewsContext";
import { useCesium } from "../../Contexts/Widget3DContext";
const upDirections = {
    up: new Cartesian3(0, 1, 0),
    left: new Cartesian3(1, 0, 0),
    down: new Cartesian3(0, -1, 0),
    right: new Cartesian3(-1, 0, 0),
};
export const CameraView = () => {
    const { viewer, viewerRef } = useCesium();
    const { views, selectedView, directionRef, selectView, canvasRef } = useCesiumViews();
    const [selectedEntityName, setSelectedEntityName] = useState("");
    const [isLocked, setIsLocked] = useState(false);
    const listenerRef = useRef(() => { });
    const offset = 5000;
    const handleViewSelectChange = (event) => {
        const viewId = Object.keys(views).find((id) => id === event.target.value);
        if (viewId) {
            setSelectedEntityName(views[viewId].name);
            selectView(viewId);
        }
    };
    const getUpdatedPosition = () => {
        const entity = viewer.entities.getById(selectedEntityName);
        const selectedDirection = directionRef.current;
        const selectedEntityPosition = entity.position.getValue(viewer.clock.currentTime);
        const selectedEntityOrientation = entity.orientation.getValue(viewer.clock.currentTime);
        const matrix = Matrix3.fromQuaternion(selectedEntityOrientation, new Matrix3());
        const aimDirection = Matrix3.multiplyByVector(matrix, new Cartesian3(0, 0, 1), new Cartesian3());
        const directionReference = upDirections[selectedDirection];
        const upDirection = Matrix3.multiplyByVector(matrix, directionReference, new Cartesian3());
        const offSetVector = Cartesian3.multiplyByScalar(aimDirection, offset, new Cartesian3());
        const newPosition = Cartesian3.add(selectedEntityPosition, offSetVector, new Cartesian3());
        return { newPosition, aimDirection, upDirection };
    };
    const updateCamera = () => {
        const { newPosition, aimDirection, upDirection } = getUpdatedPosition();
        viewer.camera.setView({
            destination: newPosition,
            orientation: {
                direction: aimDirection,
                up: upDirection,
            },
        });
    };
    const stopLocking = () => {
        selectedView.finisher(directionRef, viewerRef);
        setIsLocked(false);
        if (listenerRef) {
            viewer.clock.onTick.removeEventListener(listenerRef.current);
            if (viewer.scene.mode === 3) {
                viewer.camera.frustum = new PerspectiveFrustum({
                    fov: CesiumMath.PI_OVER_THREE,
                    aspectRatio: viewer.canvas.clientWidth / viewer.canvas.clientHeight,
                });
            }
            if (viewerRef.current) {
                viewerRef.current
                    .getElementsByClassName("cesium-widget")[0]
                    .setAttribute("style", `width:${canvasRef.current.width}px; height: ${canvasRef.current.height}px`);
            }
        }
    };
    const initiator = () => {
        canvasRef.current = {
            height: viewer.canvas.clientHeight,
            width: viewer.canvas.clientWidth,
        };
        selectedView.initiator();
        const { newPosition, aimDirection, upDirection } = getUpdatedPosition();
        viewer.camera.setView({
            destination: newPosition,
            orientation: {
                direction: aimDirection,
                up: upDirection,
            },
        });
        setIsLocked(true);
        listenerRef.current = updateCamera;
        viewer.clock.onTick.addEventListener(updateCamera);
    };
    const rotate = (rotationType) => {
        if (viewer.scene.mode === 3) {
            const rotationStates = ["left", "up", "right", "down"];
            const currentIndex = rotationStates.indexOf(directionRef.current);
            let nextValue = "";
            if (rotationType === "anticlockwise") {
                const nextIndex = currentIndex === 0 ? rotationStates.length - 1 : currentIndex - 1;
                nextValue = rotationStates[nextIndex];
            }
            else if (rotationType === "clockwise") {
                const nextIndex = currentIndex === rotationStates.length - 1 ? 0 : currentIndex + 1;
                nextValue = rotationStates[nextIndex];
            }
            directionRef.current = nextValue;
            selectedView.finisher(directionRef, viewerRef);
        }
    };
    return views && Object.keys(views).length > 0 ? (React.createElement("div", { className: "camera-widget" },
        React.createElement("div", { className: "flex-col" },
            React.createElement("label", null, "Sensor Views"),
            React.createElement("select", { className: "cesium-button", onChange: handleViewSelectChange, disabled: isLocked },
                React.createElement("option", { value: "" }, "-Select a View -"),
                Object.keys(views).map((id) => (React.createElement("option", { value: id, key: id }, views[id].name))))),
        selectedEntityName && (React.createElement("div", { className: "flex-col" },
            React.createElement("label", null, "Move"),
            isLocked ? (React.createElement("button", { className: "cesium-button", onClick: stopLocking, style: { color: "red" } }, "UnLock")) : (React.createElement("button", { className: "cesium-button", onClick: initiator }, "Watch")))),
        selectedEntityName && isLocked && (React.createElement("div", { className: "flex-col" },
            React.createElement("label", null, "Rotate"),
            React.createElement("div", { style: { display: "flex" } },
                React.createElement("button", { className: "cesium-button", onClick: () => {
                        rotate("clockwise");
                    } }, "<-"),
                React.createElement("button", { className: "cesium-button", onClick: () => {
                        rotate("anticlockwise");
                    } }, "->")))))) : null;
};
//# sourceMappingURL=CameraView.js.map